import { Outlet, Link } from "react-router-dom";

import Header from "../elements/Header";
import FooterComingsoon from "../elements/FooterComingsoon";

const LayoutComing = () => {
  return (
    <>
      <Header />
      <Outlet />
      <FooterComingsoon />
    </>
  )
};

export default LayoutComing;